<template>
  <v-snackbar
    v-model="show"
    :top="notification.top"
    :bottom="notification.bottom"
    :left="notification.left"
    :right="notification.right"
    :color="notification.colour"
    :timeout="notification.timeout"
  >
    {{ notification.text }}
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AbfAppNotifications',
  data: () => ({
    show: false,
    notification: {
      text: null,
      colour: null,
      top: false,
      bottom: true,
      left: false,
      right: false,
      timeout: 6000
    }
  }),
  computed: {
    ...mapGetters(['NotificationQueue', 'NotificationsPending'])
  },
  methods: {
    ...mapActions(['shiftNotification']),
    updateNotification() {
      if (!this.show && this.NotificationsPending) {
        this.notification = this.NotificationQueue[0];
        this.shiftNotification();

        this.$nextTick(() => {
          this.show = true;
        });
      }
    }
  },
  watch: {
    show() {
      this.updateNotification();
    },
    NotificationQueue() {
      this.updateNotification();
    }
  }
};
</script>
